import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import ToTopIcon from '@/components/UI/svg/Icons/ToTopIcon';
import { createEFPic } from '@/utils/useEFPic';

const ZA_IMG = {
    L1: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711701285175/r2p_l1_768_za.jpg',
    L2: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711701297354/r2p_l2_768_za.jpg',
    L3: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711701306291/r2p_l3_768_za.jpg',
};
const { EFPic } = createEFPic('');
export default function L() {
    const { useEffect, useState, useLang, useRouter } = useGlobal();
    const { t } = useLang('productriver2');
    const [winW, setWinW] = useState(375);
    const [swiper, setSwiper] = useState({ activeIndex: 0 });
    const { locale } = useRouter();

    const list = [
        {
            img:
                locale === 'ph'
                    ? 'https://websiteoss.ecoflow.com/upload/image/1751081534244/1.jpg'
                    : locale === 'za'
                    ? ZA_IMG.L1
                    : ['/media/river2/h5/12_1.webp', '/media/river2/h5/12_1.jpg'],
        },
        {
            img:
                locale === 'ph'
                    ? 'https://websiteoss.ecoflow.com/upload/image/1751081388129/2.jpg'
                    : locale === 'za'
                    ? ZA_IMG.L2
                    : ['/media/river2/h5/12_2.webp', '/media/river2/h5/12_2.jpg'],
        },
        {
            img:
                locale === 'ph'
                    ? 'https://websiteoss.ecoflow.com/upload/image/1751081387950/3.jpg'
                    : locale === 'za'
                    ? ZA_IMG.L3
                    : ['/media/river2/h5/12_3.webp', '/media/river2/h5/12_3.jpg'],
        },
    ];

    const onPrev = () => {
        const preIndex = swiper?.realIndex - 1;
        swiper?.slideToLoop(preIndex < 0 ? 2 : preIndex);
    };
    const onNext = () => {
        const nextIndex = (swiper?.realIndex + 1) % 3;
        swiper?.slideToLoop(nextIndex);
    };

    useEffect(() => {
        if (typeof window !== 'undefined') {
            setWinW(window?.innerWidth);
        }
        const layoutH = typeof window !== 'undefined' ? window.innerHeight : 750;
        new ScrollMagic.Scene({
            triggerElement: '.river2_details_L',
            triggerHook: 1,
            offset: layoutH,
        })
            .setClassToggle('.river2_details_L .innerBox', 'enter')
            .addTo(AniContainer);
    }, []);

    return (
        <>
            <div className={`river2_details_L ${css.L_12}`}>
                <div className={`innerBox`}>
                    <div className="title">
                        <span className="text1">{t('river2.details.sec12_title')}</span>
                        <span className="textAni">
                            <span className="textAni-in">
                                <span className="textAni-a textAni-1">{t('river2.details.sec12_title2')}</span>
                                <span className="textAni-a textAni-2">{t('river2.details.sec12_title1')}</span>
                            </span>
                        </span>
                    </div>
                    <div className="swiperBox">
                        <Swiper
                            modules={[Autoplay]}
                            className={`river2_deatails_L_swiper ${list?.length === 1 ? 'single' : ''}`}
                            slidesPerView={'auto'}
                            spaceBetween={(winW / 375) * 24}
                            initialSlide={0}
                            preloadImages={false}
                            lazy
                            loop
                            autoplay={{
                                delay: 4000,
                                disableOnInteraction: false,
                            }}
                            centeredSlides
                            grabCursor
                            onSwiper={(swiper: any) => setSwiper(swiper)}
                        >
                            {list?.map((item: any, k: number) => (
                                <SwiperSlide key={k}>
                                    {locale === 'ph' ? (
                                        <img
                                            src={item?.img}
                                            className={'fullImgs'}
                                            alt={t('river2.details.sec12_title')}
                                            aria-label={t('river2.details.sec12_title')}
                                        />
                                    ) : (
                                        <EFPic
                                            name={item?.img}
                                            className={'fullImgs'}
                                            alt={t('river2.details.sec12_title')}
                                            aria-label={t('river2.details.sec12_title')}
                                        />
                                    )}
                                </SwiperSlide>
                            ))}
                        </Swiper>
                        {list?.length > 1 && (
                            <>
                                <div className="btns">
                                    <span className="pageBtn prev" onClick={onPrev}>
                                        <ToTopIcon fill="rgba(255, 255, 255, 0.2)" fillPath="#AEAEAE" />
                                    </span>
                                    <span className="pageBtn next" onClick={onNext}>
                                        <ToTopIcon fill="rgba(255, 255, 255, 0.2)" fillPath="#AEAEAE" />
                                    </span>
                                </div>
                            </>
                        )}
                    </div>
                </div>
            </div>
            {locale === 'kr' && (
                <div className={css['product-detail-L2']}>
                    <div className="title">{t('river2.details.sec12_title3')}</div>
                    <div className="img-wrapper">
                        <EFPic
                            name={['/media/river2/h5/L_river2_details.png', '/media/river2/h5/L_river2_details.png']}
                            className="fullImgs"
                            alt={t('river2.details.sec12_title3')}
                            aria-label={t('river2.details.sec12_title3')}
                        />
                    </div>
                </div>
            )}
        </>
    );
}
